module.exports = __webpack_public_path__ + "static/media/Madfit_Website_07.aea88f64.jpg";